import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import Navbar from './Navbar';
import OverviewPage from './pages/Overview';
import ContactPage from './pages/Contact';
import AddressPage from './pages/Address';
import AccountPage from './pages/Account';
import ContractPage from './pages/ContractV2';
import SignaturePage from './pages/Signature';

import axios from 'axios';

import { SearchParams } from '../../lib/utils';

const steps = [
  // {
  //   name: 'overview',
  //   page: OverviewPage,
  // },
  // {
  //   name: 'contact',
  //   page: ContactPage,
  //   fields: {
  //     contactFields: [
  //       { name: 'givenNames', placeHolder: 'GIVEN NAME(S)' },
  //       { name: 'surname', placeHolder: 'SURNAME' },
  //       { name: 'email', placeHolder: 'EMAIL ADDRESS' },
  //       { name: 'mobile', placeHolder: 'MOBILE NUMBER' },
  //     ],
  //     shopDetailFields: [
  //       { name: 'shopName', placeHolder: 'SHOP NAME' },
  //       { name: 'shopPhone', placeHolder: 'SHOP PHONE' },
  //     ],
  //   }
  // },
  {
    name: 'address',
    page: AddressPage,
    confirming: false,
    fields: {
      storeDeliveryDetails: [
        // { name: 'shopName', placeHolder: 'SHOP NAME' },
        { name: 'buildingName', placeHolder: 'BUILDING NAME' },
        { name: 'shopPhone', placeHolder: 'SHOP PHONE' },
        { name: 'shopNumber', placeHolder: 'SHOP NUMBER' },
        { name: 'floorLevel', placeHolder: 'FLOOR/LEVEL' },
        { name: 'street1', placeHolder: 'STREET ADDRESS 1' },
        { name: 'street2', placeHolder: 'STREET ADDRESS 2' },
      ],
      storeDeliveryDetails2: [
        { name: 'suburb', placeHolder: 'SUBURB' },
        { name: 'state', placeHolder: 'STATE' },
        { name: 'postCode', placeHolder: 'POST CODE' },
      ],
      posSystemDetails: [
        { name: 'posSoftwareType', placeHolder: 'POS SOFTWARE TYPE' },
        { name: 'xchangeit', placeHolder: 'A MEMBER OF XCHANGE-IT?' },
        // { name: 'xchangeitMemberNo', placeHolder: 'XCHANGE-IT MEMBER NO.' },
      ],
      days: [
        { name: 'Monday', color: '#f1f1f1' },
        { name: 'Tuesday', color: '#ffffff' },
        { name: 'Wednesday', color: '#f1f1f1' },
        { name: 'Thursday', color: '#ffffff' },
        { name: 'Friday', color: '#f1f1f1' },
        { name: 'Saturday', color: '#ffffff' },
        { name: 'Sunday', color: '#f1f1f1' },
      ]
    }
  },
  {
    name: 'account',
    page: AccountPage,
    fields: {
      // financialAccountDetails: [
      //   { name: 'surNameOrCompanyName', placeHolder: 'SURNAME OR COMPANY NAME' },
      //   { name: 'abn', placeHolder: 'ABN' },
      // ],
      financialAccountDetails2: [
        { name: 'nameOfFinancialInstitution', placeHolder: 'NAME OF FINANCIAL INSTITUTION' },
        { name: 'namesOnAccount', placeHolder: 'NAME(S) ON ACCOUNT' },
        { name: 'bsb', placeHolder: 'BSB' },
        { name: 'accountNumber', placeHolder: 'ACCOUNT NUMBER' },
      ],
      toggle: [
        { name: 'goodsCareCustodyConfirmation' },
      ],
    },
  },
  { name: 'contract', page: ContractPage },
  // { name: 'signature', page: SignaturePage },
];

export default class SignupMain extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.onClickLeft = this.onClickLeft.bind(this);
    this.onClickStep = this.onClickStep.bind(this);
    this.onClickRight = this.onClickRight.bind(this);
    this.updateDocLink = this.updateDocLink.bind(this);

    this.state = {
      currentActive: 0,
      errors: {},
      contact: {
        valid: false,
        givenNames: '',
        surname: '',
        email: '',
        mobile: '',
        shopName: '',
        shopPhone: '',
        licensedPostOffice: false,
      },
      address: {
        valid: false,
        customAddress: '',
        // shopName: '',
        shopPhone: '',
        buildingName: '',
        shopNumber: '',
        floorLevel: '',
        street1: '',
        street2: '',
        suburb: '',
        state: 'NSW',
        postCode: '',
        posSoftwareType: 'none',
        xchangeit: 'No',
        xchangeitMemberNo: '',
        Monday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Tuesday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Wednesday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Thursday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Friday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Saturday: { open: true, from: '7:00 am', to: '6:00 pm' },
        Sunday: { open: true, from: '7:00 am', to: '6:00 pm' },
        latlng: { lat: 0, lng: 0 },
      },
      account: {
        valid: false,
        surNameOrCompanyName: '',
        abn: '',
        nameOfFinancialInstitution: '',
        namesOnAccount: '',
        bsb: '',
        accountNumber: '',
        goodsCareCustodyYes: false,
        goodsCareCustodyNotYet: true,
        goodsCareCustodyConfirmation: false,
        individual: true,
        corporation: false,
      },
      contract: {
        contractDownloadLink: '',
        valid: false,
      },
      // signature: {
      //   dataUrl: null,
      // },
    };
  }

  componentDidMount() {
    const queryParams = this.props.location.search;
    const params = new SearchParams(queryParams);
    const completeContractToken = params.get('completeContractToken');

    axios.post('/api/account/complete-contract', {
      completeContractToken,
    }).then(({ data }) => {
      if (data && !data.newsagency) return window.location.replace('/signup');

      const { newsagency } = data;
      const {
        abn,
        contactName,
        email,
        isLicensedPostOffice,
        phone,
        shopName,
      } = newsagency;

      const splitName = contactName.split(' ');
      const givenNames = splitName.slice(0, splitName.length - 1).join(' ');
      this.setState({
        contact: Object.assign(this.state.contact, {
          givenNames: givenNames || splitName[splitName.length - 1],
          surname: givenNames ? splitName[splitName.length - 1] : '',
          email,
          mobile: phone,
          shopName,
          licensedPostOffice: isLicensedPostOffice,
        }),
        address: Object.assign(this.state.address, {
          shopName,
        }),
        account: Object.assign(this.state.account, {
          abn,
        }),
      });
		}).catch((err) => {
			this.setState({ error: err });
		});
  }

  onSubmit() {
    const queryParams = this.props.location.search;
    const params = new SearchParams(queryParams);
    const completeContractToken = params.get('completeContractToken');

    const {
      contact,
      address,
      account,
      contract,
    } = this.state;

    axios.post('/api/account/complete-contract-data', {
      completeContractToken,
      contact,
      address,
      account,
      contract,
      signature: { dataUrl: null },
    }).then(({ data }) => {
      console.log('done', data);
      // window.location.replace('/signup-complete');
    }).catch((err) => {
      console.log('error', err);
    });
  }

  onChange(page) {
    return (name) => {
      return (e) => {
        if (name === 'contract') {
          return this.setState({
            [page]: Object.assign(this.state[page], {
              contractDownloadLink: e,
              valid: true,
            }),
          }, this.onSubmit);
        }

        const isToggle = [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ].indexOf(name) > -1;

        if (isToggle) {
          return this.setState({
            [page]: Object.assign({}, this.state[page], {
              [name]: e,
            }),
          }, () => {
            let valid = true;
            const { fields } = steps[this.state.currentActive];
            Object.keys(fields).forEach((field) => {
              fields[field].forEach((fieldObj) => {
                const fieldName = fieldObj.name;
                // console.log('> page', page, fieldName);
                const validField = this.validateField(fieldName, this.state[page][fieldName]);
                // console.log('here', fieldName, validField);
                if (!validField) valid = false;
              });
            });

            this.setState({
              [page]: Object.assign({}, this.state[page], {
                valid,
              }),
            });
          });
        }

        const customField = [
          'latlng',
        ].indexOf(name) > -1;

        if (customField) {
          return this.setState({
            [page]: Object.assign({}, this.state[page], {
              [name]: e,
            }),
          });
        }

        const lastCustomField = [
          'dataUrl',
        ].indexOf(name) > -1;

        if (lastCustomField) {
          return this.setState({
            [page]: Object.assign({}, this.state[page], {
              [name]: e,
            }),
          });
        }

        const isCheckbox = [
          'goodsCareCustodyYes',
          'goodsCareCustodyNotYet',
          'goodsCareCustodyConfirmation',
          'individual',
          'corporation',
          'licensedPostOffice'
        ].indexOf(name) > -1;
        if (!isCheckbox && e.preventDefault) e.preventDefault();

        if (name === 'abn' && (e.target.value.length > 11 || isNaN(e.target.value))) {
          return;
        }

        if (name === 'bsb' && (e.target.value.length > 6 || isNaN(e.target.value))) {
          return;
        }

        if (name === 'postCode' && (e.target.value.length > 4 || isNaN(e.target.value))) {
          return;
        }

        const targetVal = e.target.value;
        this.setState({
          [page]: Object.assign({}, this.state[page], {
            [name]: isCheckbox ? !this.state[page][name] : targetVal,
            errors: {},
          }),
        }, () => {
          const { fields } = steps[this.state.currentActive];
          if (fields) {
            let valid = true;
            // console.log('test', Object.keys(fields))
            Object.keys(fields).forEach((field) => {
              fields[field].forEach((fieldObj) => {
                const fieldName = fieldObj.name;
                // console.log('> page', page, fieldName);
                const validField = this.validateField(fieldName, this.state[page][fieldName]);
                // console.log('here', fieldName, validField);
                if (!validField) valid = false;
              });
            });

            this.setState({
              errors: {},
              [page]: Object.assign(this.state[page], {
                valid,
              }),
            });
          }

          const toggleFields = [
            'goodsCareCustodyYes',
            'goodsCareCustodyNotYet',
            'individual',
            'corporation',
          ].indexOf(name) > -1;

          const toggleAlternates = {
            goodsCareCustodyYes: 'goodsCareCustodyNotYet',
            goodsCareCustodyNotYet: 'goodsCareCustodyYes',
            individual: 'corporation',
            corporation: 'individual',
          };

          if (toggleFields) {
            this.setState({
              [page]: Object.assign({}, this.state[page], {
                [toggleAlternates[name]]: !this.state[page][name],
              }),
            });
          }
        });
      };
    }
  }

  validateField(field, value) {
    const {
      Monday,
      Tuesday,
      Wednesday,
      Thursday,
      Friday,
      Saturday,
      Sunday,
    } = this.state.address;

		switch (field) {
			case 'givenNames':
				return value && value.length > 0;
      case 'licensedPostOffice':
      case 'Monday':
      case 'Tuesday':
      case 'Wednesday':
      case 'Thursday':
      case 'Friday':
      case 'Saturday':
      case 'Sunday':
        return Monday.open || Tuesday.open || Wednesday.open || Thursday.open || Friday.open || Saturday.open || Sunday.open;
      case 'shopNumber':
      case 'buildingName':
      case 'floorLevel':
      case 'street2':
      case 'xchangeit':
      case 'xchangeitMemberNo':
        return true;
      case 'bsb':
        return value && value.length === 6;
      case 'goodsCareCustodyConfirmation':
        return value;
			default:
				return value && value.length > 0;
		}
  }

  onClickLeft() {
    if (this.state.currentActive === 0) return;
    this.setState({
      currentActive: this.state.currentActive - 1,
    });
  }

  onClickStep(index) {
    return () => {
      if (this.state.currentActive === index) return;
      if (this.state.currentActive < index) return;

      this.setState({
        currentActive: index,
      });
    };
  }

  onClickRight() {
    if (this.state.currentActive >= steps.length) return;
    const currentPage = steps[this.state.currentActive];
    const { name, fields } = currentPage;

    const currentPageName = name;
    const data = this.state[currentPageName];
    const errors = {};

    if (!this.state[name]) {
      return this.setState({
        currentActive: this.state.currentActive + 1,
        errors,
      });
    }

    Object.keys(fields || {}).forEach((parentField) => {
      fields[parentField].forEach((field) => {
        if (!this.validateField(field.name, data[field.name])) {
          errors[field.name] = true;
        }
        // console.log('field', field.name, errors[field.name]);
      });
    });

		if (Object.keys(errors).length > 0) {
			return this.setState({ errors });
    }

    if (name === 'address' && this.state[name].valid) {
      if (!this.state[currentPage.name].confirming) {
        /* eslint-disable-next-line */
        window.amplitude.getInstance().logEvent('Address Next button Click');

        return this.setState({
          [currentPage.name]: Object.assign({}, this.state[currentPage.name], {
            confirming: true,
          }),
        });
      }
    }

    if (this.state[name].valid) {
      if (name === 'contract') {
        window.location.replace('/signup-complete');
        // return this.onSubmit();
      }

      this.setState({
        currentActive: this.state.currentActive + 1,
        errors,
      });
    }
  }

  async updateDocLink(contractDownloadLink) {
    const queryParams = window.location.search;
    const params = new SearchParams(queryParams);
    const completeContractToken = params.get('completeContractToken');
    await axios.post('/api/account/update-contract-link', {
      completeContractToken,
      contractDownloadLink,
    });
  }

  render() {
    /* eslint-disable-next-line */
    const queryParams = window.location.search;
    const params = new SearchParams(queryParams);
    const completeContractToken = params.get('completeContractToken');

    const currentStep = steps[this.state.currentActive];
    const currentPageName = currentStep.name;
    const CurrentPage = currentStep.page;
    const { fields } = currentStep;

    const prevPage = steps[this.state.currentActive - 1]
    const prevPageData = prevPage ? this.state[prevPage.name] : null;

    const currentPage = this.state[currentPageName];

    let pageName;
    switch (currentPageName) {
      case 'address': {
        pageName = 'SignupAddress';
        if (currentPage.confirming) pageName = 'SignupAddressVerify';
        break;
      }
      case 'account': {
        pageName = 'SignupAccount';
        break;
      }
      case 'contract': {
        pageName = 'SignupContract';
        if (currentPage.valid) pageName = 'SignupContractSigned';
        break;
      }
      default: {
        break;
      }
    }

    // const queryPageName = params.get('step');
    /* eslint-disable-next-line */
    const queryHash = window.location.hash;
    const currentHash = `#${pageName}`;
    if (queryHash !== currentHash) {
      /* eslint-disable-next-line */
      // history.pushState({}, '', `?completeContractToken=${completeContractToken}&step=${pageName}`);
      /* eslint-disable-next-line */
      history.pushState({}, '', currentHash);
    }

    return (
      <div>
        <Navbar
          valid={currentPage ? currentPage.valid : true}
          currentActive={this.state.currentActive}
          steps={steps}
          onClickLeft={this.onClickLeft}
          onClickStep={this.onClickStep}
          onClickRight={this.onClickRight}
        />
        <Container>
          <div style={{ marginTop: 80 }}>
            <CurrentPage
              googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3&libraries=places&key=${process.env.REACT_APP_GOOGLE_API_KEY}`}
              loadingElement={<div style={{ height: `100%` }} />}
              completeContractToken={completeContractToken}
              data={this.state[currentPageName]}
              prevPageData={prevPageData}
              allData={{
                contact: this.state.contact,
                address: this.state.address,
                account: this.state.account,
                contract: this.state.contract,
              }}
              fields={fields}
              errors={this.state.errors}
              onChange={this.onChange(currentPageName)}
              onSubmit={this.onSubmit}
              updateDocLink={this.updateDocLink}
            />
          </div>
        </Container>
      </div>
    )
  }
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/index.js